import React, { useState, useContext } from 'react';
import axios from 'axios';


export type FindOrderRequest = {
  order_number: string,
  postal_code: string
}

export enum ReturnType {
  FlatPerOrder = 'consumer_flat_per_order'
}

export type CostOption = {
  type: ReturnType,
  cost: {
    amount: string,
    currency_code: string,
  },
  carrier_code: string,
  title: string,
  text: string
}

export type SalesOrderWithReturnEligibility = {
  sales_order_id: string,
  order_number: string,
  order_date: string,
  is_return_eligible: boolean,
  reason?: null | string,
  eligible_until_timestamp: string,
  return_cost_options: [CostOption]
}

export type OrderState = {
  postal_code?: string,
  setPostalCode: (postal_code: string) => void,
  order?: SalesOrderWithReturnEligibility,
  setOrder: (order: SalesOrderWithReturnEligibility) => void,
}

const OrderStateContext = React.createContext<OrderState | null>(null);

export const OrderStateProvider = ({ children }:{ children: React.ReactNode }) => {
  const [postal_code,setPostalCode] = useState<string | undefined>(undefined);
  const [order,setOrder] = useState<SalesOrderWithReturnEligibility | undefined>(undefined);

  return <OrderStateContext.Provider value={{ order, setOrder, postal_code, setPostalCode }}>
    {children}
  </OrderStateContext.Provider>;
};


export const useOrderState = () : OrderState => {
  const orderContext = useContext(OrderStateContext);
  return {
    postal_code: orderContext?.postal_code,
    setPostalCode: orderContext?.setPostalCode as (p: string) => void,
    order: orderContext?.order,
    setOrder: orderContext?.setOrder as (o: SalesOrderWithReturnEligibility) => void
  };
};

export const useFindOrder = (returnsCenterId: string | null) => {
  const { setPostalCode, setOrder } = useOrderState();
  const [loading,setLoading] = useState(false);
  const [form, setForm] = useState<FindOrderRequest>({ order_number: '', postal_code: '' });
  const [error,setError] = useState<any>();

  const setField = ({ name, value }:{ name: string, value: string }) => {
    setError(null);
    setForm( oldForm => ({ ...oldForm, [name]: value }) );
  };

  const findOrder = ({ order_number='', postal_code='' }:FindOrderRequest) => {
    setPostalCode(postal_code);
    setError(null);
    setLoading(true);
    axios.get(`/public/${returnsCenterId}/search?order_number=${order_number}&postal_code=${postal_code}`).then(
      ({ data }) => {
        setLoading(false);
        setOrder(data);
      },
      (error) => {
        setError('There was a problem finding your order, please try again.');
        setLoading(false);
      }
    );
  };

  return { setField, form, findOrder, loading, error };
};
